(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("splitAF", [], factory);
	else if(typeof exports === 'object')
		exports["splitAF"] = factory();
	else
		root["splitAF"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 